export default __webpack_public_path__ + "static/media/ZION-logo-white.0ae25723.png";